import React from 'react';

export const configurationPagesConfig = [
  {
    auth: ['admin', 'user'],
    routes: [
      {
        path: '/configuration',
        component: React.lazy(() => import('./Pages')),
      },
    ],
  },
];
